import BaseButton from "components/disw/BaseButton";
import {
  RestrictedSolutionRealm,
  SolutionPermission
} from "features/access-management";
import { FormikProps } from "formik";
import {
  NotificationTriggerInput,
  ServiceProductStatus
} from "model/schema/globalTypes";
import React, { RefObject } from "react";

interface ServiceProductNotificationActionsProps {
  notificationReadOnly: boolean;
  onDeactivate?: () => void;
  onClose?: () => void;
  onCancel?: (e: React.MouseEvent<HTMLButtonElement>) => void;

  serviceProductStatus: ServiceProductStatus;
  deactivatableStatuses: ServiceProductStatus[];
  notificationSettingRef: RefObject<FormikProps<{
    notificationTriggers: NotificationTriggerInput[];
  }> | null>;
}
const ServiceProductNotificationActions: React.FC<
  ServiceProductNotificationActionsProps
> = ({
  notificationReadOnly,
  onDeactivate,
  onClose,
  onCancel,
  serviceProductStatus,
  deactivatableStatuses,
  notificationSettingRef
}) => {
  return (
    <>
      <RestrictedSolutionRealm
        silent
        requiredPermissions={[SolutionPermission.ChangeServiceProducts]}
      >
        {Boolean(onDeactivate && notificationReadOnly) &&
          deactivatableStatuses.includes(serviceProductStatus) && (
            <BaseButton
              text="Deactivate"
              type="button"
              styleType="error"
              onClick={e => {
                e.stopPropagation();
                onDeactivate && onDeactivate();
              }}
            />
          )}
      </RestrictedSolutionRealm>
      {!notificationReadOnly && (
        <RestrictedSolutionRealm
          silent
          requiredPermissions={[SolutionPermission.ChangeServiceProducts]}
        >
          <BaseButton
            text="Cancel"
            type="button"
            styleType="default"
            onClick={e => {
              if (notificationSettingRef.current) {
                notificationSettingRef.current.resetForm();
              }
              if (onCancel) onCancel(e);
            }}
          />

          <BaseButton
            text="Save"
            type="submit"
            styleType="base"
            onClick={() => {
              if (notificationSettingRef.current) {
                notificationSettingRef.current.submitForm();
              }
            }}
          />
        </RestrictedSolutionRealm>
      )}
      {notificationReadOnly && (
        <BaseButton
          text="Close"
          type="button"
          styleType="base"
          onClick={e => {
            e.stopPropagation();
            onClose && onClose();
          }}
        />
      )}
    </>
  );
};

export default ServiceProductNotificationActions;
